export const resources = {
  ko: {
    translation: {
      siteDescription: "Prosense는 할인율, 판매량, 리뷰 신호를 바탕으로 AliExpress 핫딜과 프로모션을 선별하는 데이터 기반 쇼핑 큐레이션입니다.",
      brandTagline: "알리 핫딜 큐레이션",
      homeEyebrow: "오늘 볼 만한 알리 쇼핑 큐레이션",
      homeHeroTitle: "싼 상품보다, 살 만한 딜을 먼저 보여드려요.",
      homeHeroDescription: "Prosense는 할인율, 누적 판매, 리뷰 신호를 함께 보고 AliExpress 상품을 정리합니다. 광고처럼 떠미는 리스트가 아니라 빠르게 비교하고 클릭할 수 있는 핫딜 쇼핑 보드입니다.",
      curatedNow: "지금 선별한 딜",
      dealFeed: "핫딜 피드",
      dealFeedDescription: "가격, 할인율, 판매량, 평점 흐름을 함께 보며 업데이트한 상품입니다.",
      curationStandard: "큐레이션 기준",
      curationStandardDescription: "과장된 문구보다 비교에 필요한 신호를 앞에 둡니다.",
      curationDiscount: "실제 구매 판단에 필요한 할인율과 가격을 먼저 확인합니다.",
      curationDemand: "누적 판매량과 리뷰 신호로 검증된 수요를 함께 봅니다.",
      curationFreshness: "상품과 프로모션 데이터를 계속 갱신해 오래된 딜 노출을 줄입니다.",
      affiliateDisclosure: "Prosense는 AliExpress 제휴 링크를 사용할 수 있으며, 구매가 발생하면 추가 비용 없이 수수료를 받을 수 있습니다.",
      trustSignals: "선별 기준",
      todaysPicks: "오늘의 추천",
      compareDeals: "딜 비교하기",
      openDeal: "딜 보기",
      shopNow: "AliExpress 특가 확인",
      productCheckTitle: "구매 전 체크",
      productCheckPrice: "현재 판매가와 원가 표시를 함께 비교하세요.",
      productCheckReviews: "상세 페이지에서 실제 리뷰와 배송 조건을 한 번 더 확인하세요.",
      productCheckDisclosure: "외부 구매는 AliExpress에서 진행됩니다.",
      curatedByProsense: "Prosense 선별",
      navigation: "주요 메뉴",
      footerPromise: "Prosense는 AliExpress의 방대한 상품 중 비교 가치가 있는 딜을 보기 쉽게 정리합니다.",
      footerCopyright: "{{siteName}}에 게재된 모든 상품 정보와 이미지의 저작권은 AliExpress와 각 판매자에게 있습니다.",
      more: "더보기",
      viewMore: "더보기",
      showMore: "더보기",
      hotDeals: "핫딜 상품",
      all: "전체",
      privacyPolicy: "개인정보 처리방침",
      footerText: "{{siteName}}은 제휴 마케팅 활동의 일환으로 수수료를 받을 수 있습니다.",
      menu: "메뉴",
      close: "닫기",
      copy: "복사",
      promoCode: "프로모션 코드",
      copiedPromoCodeMessage: "프로모션 코드가 복사되었습니다.",
      productDescription: "상품 정보",
      relatedItems: "연관 상품",
      buyOnAliExpress: "AliExpress에서 구매",
      sold: "누적 판매",
      expires: "유효기간",
      discount: "할인",
      averageReviewRating: "평균 리뷰 평점",
      search: "검색...",
      searchResults: "{{value}} 개의 검색 결과",
      termsOfService: "서비스 약관",
      about: "사이트 소개",
      reviews: "리뷰",
      checkReviewsOnAliExpress: "AliExpress에서 리뷰 보기",
      productHidden: "판매가 중단된 상품입니다.",
      brands: "브랜드",
      brandsDescription: "알리익스프레스의 모든 브랜드를 한눈에 확인하세요",
      "brands.allBrands": "전체 브랜드",
      category: {
        electronics: "전자제품",
        fashion: "패션",
        home: "홈/가구",
        sports: "스포츠/레저",
        health: "건강/뷰티",
        kids: "키즈/베이비",
        office: "사무용품",
        other: "기타"
      },
      products: "상품",
      productsCapital: "상품",
      promotions: "프로모션",
      allPromotions: "모든 프로모션",
      viewAllPromotions: "모든 프로모션 보기",
      noPromotions: "등록된 프로모션이 없습니다",
      backToPromotions: "프로모션 목록으로 돌아가기",
      promotionsDescription: "알리익스프레스의 최신 프로모션을 확인하세요",
      viewDetails: "상세 보기",
      visitPromotion: "방문하기",
      backToHome: "홈으로 돌아가기",
      notFoundPromotion: "프로모션을 찾을 수 없습니다",
      lastUpdated: "마지막 업데이트",
      homeIntro: "알리익스프레스 핫딜만 엄선해 모았습니다. 할인율, 판매량, 리뷰 점수를 반영한 추천 상품을 만나 보세요.",
      categoryIntro: "이 카테고리에서 인기 있는 할인 상품입니다.",
      searchNoResults: "검색 결과가 없습니다.",
      searchNoResultsHint: "다른 키워드나 카테고리를 시도해 보세요.",
      showingCount: "{{from}}–{{to}} / {{total}}개 표시",
      loadingMore: "불러오는 중…",
      otherCategories: "다른 카테고리",
      footerBrowse: "둘러보기",
    }
  },
  en: {
    translation: {
      siteDescription: "Get hot deals on AliExpress and enjoy incredible savings while shopping smarter!",
      footerCopyright: "The copyright for all product information and images on {{siteName}} belongs to AliExpress and the respective sellers.",
      more: "More",
      viewMore: "View More",
      showMore: "Show More",
      hotDeals: "Hot Deals",
      all: "All",
      privacyPolicy: "Privacy Policy",
      footerText: "{{siteName}} may earn a commission as part of its affiliate marketing activities.",
      menu: "Menu",
      close: "Close",
      copy: "Copy",
      promoCode: "Promo Code",
      copiedPromoCodeMessage: "The promo code has been copied.",
      productDescription: "Description",
      relatedItems: "Related items",
      buyOnAliExpress: "Buy on AliExpress",
      sold: "sold",
      expires: "Expires",
      discount: "Discount",
      averageReviewRating: "Average Review Rating",
      search: "Search...",
      searchResults: "{{value}} results",
      termsOfService: "Terms of Service",
      about: "About",
      reviews: "Reviews",
      checkReviewsOnAliExpress: "Check Reviews on AliExpress",
      productHidden: "This product has been discontinued.",
      brands: "Brands",
      brandsDescription: "Discover all brands on AliExpress at a glance",
      "brands.allBrands": "All Brands",
      category: {
        electronics: "Electronics",
        fashion: "Fashion",
        home: "Home & Furniture",
        sports: "Sports & Leisure",
        health: "Health & Beauty",
        kids: "Kids & Baby",
        office: "Office Supplies",
        other: "Others"
      },
      products: "products",
      productsCapital: "Products",
      promotions: "Promotions",
      allPromotions: "All Promotions",
      viewAllPromotions: "View All Promotions",
      noPromotions: "No promotions available",
      backToPromotions: "Back to Promotions",
      promotionsDescription: "Check out the latest promotions on AliExpress",
      viewDetails: "View Details",
      visitPromotion: "Visit",
      backToHome: "Back to Home",
      notFoundPromotion: "Promotion not found",
      lastUpdated: "Last Updated",
      homeIntro: "We curate the best hot deals on AliExpress. Discover recommended products based on discount rate, sales volume, and reviews.",
      categoryIntro: "Popular discounted products in this category.",
      searchNoResults: "No search results.",
      searchNoResultsHint: "Try different keywords or categories.",
      showingCount: "Showing {{from}}–{{to}} of {{total}}",
      loadingMore: "Loading…",
      otherCategories: "Other categories",
      footerBrowse: "Browse",
    }
  },
  ja: {
    translation: {
      siteDescription: "アリエクスプレスでお得なセールをお見逃しなく！スマートに買い物して、驚きの割引を楽しもう！",
      footerCopyright: "{{siteName}}に掲載されているすべての商品情報と画像の著作権はAliExpressと各販売者に帰属します。",
      more: "もっと見る",
      viewMore: "もっと見る",
      showMore: "もっと見る",
      hotDeals: "お買い得商品",
      all: "すべて",
      privacyPolicy: "プライバシーポリシー",
      footerText: "{{siteName}}はアフィリエイトマーケティング活動の一環として手数料を得る場合があります。",
      menu: "メニュー",
      close: "閉じる",
      copy: "コピー",
      promoCode: "プロモーションコード",
      copiedPromoCodeMessage: "プロモーションコードがコピーされました。",
      productDescription: "概要",
      relatedItems: "関連アイテム",
      buyOnAliExpress: "AliExpressで購入",
      sold: "販売済み",
      expires: "有効期限",
      discount: "割引",
      averageReviewRating: "平均レビュー評価",
      search: "検索...",
      searchResults: "{{value}} 件の検索結果",
      termsOfService: "サービス規約",
      about: "サイトについて",
      reviews: "レビュー",
      checkReviewsOnAliExpress: "AliExpressでレビューを見る",
      productHidden: "この商品は廃止されました。",
      brands: "ブランド",
      brandsDescription: "アリエクスプレスのすべてのブランドを一目で確認できます",
      "brands.allBrands": "すべてのブランド",
      category: {
        electronics: "電子機器",
        fashion: "ファッション",
        home: "ホーム＆家具",
        sports: "スポーツ＆レジャー",
        health: "健康＆ビューティー",
        kids: "キッズ＆ベビー",
        office: "オフィス用品",
        other: "その他"
      },
      products: "商品",
      productsCapital: "商品",
      promotions: "プロモーション",
      allPromotions: "全てのプロモーション",
      viewAllPromotions: "全てのプロモーションを見る",
      noPromotions: "プロモーションがありません",
      backToPromotions: "プロモーション一覧に戻る",
      promotionsDescription: "アリエクスプレスの最新プロモーションをチェック",
      viewDetails: "詳細を見る",
      visitPromotion: "訪問する",
      backToHome: "ホームに戻る",
      notFoundPromotion: "プロモーションが見つかりません",
      lastUpdated: "最終更新",
      homeIntro: "アリエクスプレスのお買い得商品を厳選しました。割引率・販売数・レビューを反映したおすすめ商品をご覧ください。",
      categoryIntro: "このカテゴリの人気割引商品です。",
      searchNoResults: "検索結果がありません。",
      searchNoResultsHint: "別のキーワードやカテゴリをお試しください。",
      showingCount: "{{from}}–{{to}} / {{total}}件を表示",
      loadingMore: "読み込み中…",
      otherCategories: "他のカテゴリ",
      footerBrowse: "ブラウズ",
    }
  },
  ru: {
    translation: {
      siteDescription: "Не упустите горячие предложения на AliExpress и наслаждайтесь невероятными скидками, покупая более умно!",
      footerCopyright: "Авторское право на всю информацию о продукте и изображения на {{siteName}} принадлежит AliExpress и соответствующим продавцам.",
      more: "Больше",
      viewMore: "Посмотреть больше",
      showMore: "Показать больше",
      hotDeals: "Горячие предложения",
      all: "Все",
      privacyPolicy: "Политика конфиденциальности",
      footerText: "{{siteName}} может получать комиссию в рамках своей партнерской маркетинговой деятельности.",
      menu: "Меню",
      close: "Закрыть",
      copy: "Копировать",
      promoCode: "Промо-код",
      copiedPromoCodeMessage: "Промо-код был скопирован.",
      productDescription: "Описание товара",
      relatedItems: "Связанные товары",
      buyOnAliExpress: "Купить на AliExpress",
      sold: "продано",
      expires: "Истекает",
      discount: "Скидка",
      averageReviewRating: "Средний рейтинг отзывов",
      search: "Поиск...",
      searchResults: "{{value}} результатов",
      termsOfService: "Условия использования",
      about: "О нас",
      reviews: "Отзывы",
      checkReviewsOnAliExpress: "Посмотреть отзывы на AliExpress",
      productHidden: "Этот товар был прекращен.",
      brands: "Бренды",
      brandsDescription: "Откройте для себя все бренды на AliExpress одним взглядом",
      "brands.allBrands": "Все бренды",
      category: {
        electronics: "Электроника",
        fashion: "Мода",
        home: "Дом и мебель",
        sports: "Спорт и отдых",
        health: "Здоровье и красота",
        kids: "Дети и младенцы",
        office: "Канцелярские товары",
        other: "Другое"
      },
      products: "товары",
      productsCapital: "Товары",
      promotions: "Акции",
      allPromotions: "Все акции",
      viewAllPromotions: "Посмотреть все акции",
      noPromotions: "Нет доступных акций",
      backToPromotions: "Вернуться к акциям",
      promotionsDescription: "Ознакомьтесь с последними акциями на AliExpress",
      viewDetails: "Подробнее",
      visitPromotion: "Посетить",
      backToHome: "Вернуться на главную",
      notFoundPromotion: "Акция не найдена",
      lastUpdated: "Последнее обновление",
      homeIntro: "Мы отбираем лучшие предложения AliExpress. Рекомендуемые товары по скидкам, продажам и отзывам.",
      categoryIntro: "Популярные товары со скидкой в этой категории.",
      searchNoResults: "Результатов не найдено.",
      searchNoResultsHint: "Попробуйте другие слова или категории.",
      showingCount: "Показано {{from}}–{{to}} из {{total}}",
      loadingMore: "Загрузка…",
      otherCategories: "Другие категории",
      footerBrowse: "Навигация",
    }
  },
  es: {
    translation: {
      siteDescription: "¡No te pierdas las ofertas de AliExpress y disfruta de increíbles ahorros comprando de forma más inteligente!",
      footerCopyright: "Los derechos de autor de toda la información del producto y las imágenes en {{siteName}} pertenecen a AliExpress y a los respectivos vendedores.",
      more: "Más",
      viewMore: "Ver más",
      showMore: "Mostrar más",
      hotDeals: "Ofertas",
      all: "Todos",
      privacyPolicy: "Política de privacidad",
      footerText: "{{siteName}} puede ganar una comisión como parte de sus actividades de marketing de afiliados.",
      menu: "Menú",
      close: "Cerrar",
      copy: "Copiar",
      promoCode: "Código promocional",
      copiedPromoCodeMessage: "El código promocional ha sido copiado.",
      productDescription: "Descripción",
      relatedItems: "Productos relacionados",
      buyOnAliExpress: "Comprar en AliExpress",
      sold: "vendido",
      expires: "Caduca",
      discount: "Descuento",
      averageReviewRating: "Calificación promedio de la reseña",
      search: "Buscar...",
      searchResults: "{{value}} resultados",
      termsOfService: "Términos de servicio",
      about: "Acerca de",
      reviews: "Reseñas",
      checkReviewsOnAliExpress: "Ver reseñas en AliExpress",
      productHidden: "Este producto ha sido descontinuado.",
      brands: "Marcas",
      brandsDescription: "Descubre todas las marcas en AliExpress de un vistazo",
      "brands.allBrands": "Todas las marcas",
      category: {
        electronics: "Electrónica",
        fashion: "Moda",
        home: "Hogar y muebles",
        sports: "Deportes y ocio",
        health: "Salud y belleza",
        kids: "Niños y bebés",
        office: "Material de oficina",
        other: "Otros"
      },
      products: "productos",
      productsCapital: "Productos",
      promotions: "Promociones",
      allPromotions: "Todas las promociones",
      viewAllPromotions: "Ver todas las promociones",
      noPromotions: "No hay promociones disponibles",
      backToPromotions: "Volver a promociones",
      promotionsDescription: "Consulta las últimas promociones en AliExpress",
      viewDetails: "Ver detalles",
      visitPromotion: "Visitar",
      backToHome: "Volver al inicio",
      notFoundPromotion: "Promoción no encontrada",
      lastUpdated: "Última actualización",
      homeIntro: "Seleccionamos las mejores ofertas de AliExpress. Productos recomendados por descuento, ventas y reseñas.",
      categoryIntro: "Productos con descuento populares en esta categoría.",
      searchNoResults: "No hay resultados.",
      searchNoResultsHint: "Prueba otras palabras o categorías.",
      showingCount: "Mostrando {{from}}–{{to}} de {{total}}",
      loadingMore: "Cargando…",
      otherCategories: "Otras categorías",
      footerBrowse: "Explorar",
    }
  }
}; 
